import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";
import styled from "styled-components/macro";

function MoneyPerMonth({ price, perDescription }) {
  let firstTwoDigits;
  let lastTwoDigits;
  firstTwoDigits = price?.toString()?.split(".")?.shift();
  lastTwoDigits = price?.toString()?.split(".")?.pop();
  if (price?.toString()?.includes(".")) {
    firstTwoDigits = price?.toString()?.split(".")?.shift();
    lastTwoDigits = price?.toString()?.split(".")?.pop();
  } else {
    firstTwoDigits = price?.toString();
    lastTwoDigits = "00";
  }

  // console.log(firstTwoDigits);

  const { t } = useTranslation();
  return (
    <MoneyBox>
      <StyledTypography variant="h3">{firstTwoDigits}.</StyledTypography>
      <RightTwoDigits>
        <StyledTypography variant="h6">{lastTwoDigits}</StyledTypography>
        <Typography variant="h6">
          {perDescription != null ? perDescription : t("/Year")}
        </Typography>
      </RightTwoDigits>
    </MoneyBox>
  );
}

const MoneyBox = styled(Box)`
  display: flex;
  height: 100%;
`;

const RightTwoDigits = styled(Box)`
  display: flex;
  height: 100%;
  margin-top: 1rem;
`;

const StyledTypography = styled(Typography)`
  color: ${(props) => props.theme.palette.primary.main};
`;

export default MoneyPerMonth;
